import React from 'react'
import tw from 'tailwind-styled-components'
import {Lang} from 'yougile-lang'
import {LinkButtonNew} from '@components/common/base/buttons'

const TwShowArchivedButton = tw(LinkButtonNew)`
  !w-full
  h-32
  py-8
  px-12
`

export interface ShowArchivedButtonProps {
  count: number
  expanded: boolean
  onClick: () => void
  className?: string
}

export const ShowArchivedButton = ({
  count,
  expanded,
  onClick,
  className
}: ShowArchivedButtonProps) => (
  <TwShowArchivedButton
    color="secondary"
    title={Lang.msg.archivedTasks + ' (' + count + ')'}
    iconAfter={expanded ? 'IconChevronUp' : 'IconChevronDown'}
    onClick={onClick}
    className={className}
  />
)
